import { Navigate, useLocation } from 'react-router-dom';
import type { LegacyPermissionKey } from '../config/legacyPermissions';
import { usePermissions } from '../hooks/usePermissions';

interface ProtectedRouteProps {
  children: React.ReactElement;
  requiredPermissions?: LegacyPermissionKey[];
}

function ProtectedRoute({ children, requiredPermissions }: ProtectedRouteProps) {
  const { hasPermissions } = usePermissions();
  const location = useLocation();

  if (!hasPermissions(requiredPermissions)) {
    return <Navigate to="/forbidden" state={{ from: location }} replace />;
  }

  return children;
}

export default ProtectedRoute;
